import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import { Calendar } from 'primereact/calendar';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import BottomPopup from './BottomPopup';
import callToggle from '../store/actions/callToggle';
import userIcon from '../assets/icons/userIcon.svg';
import { houseCall } from '../store/actions/anyRequests';

function HouseCall() {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState('');
  const { visible, item = {}, isCall } = useSelector((state) => state.callToggle);
  const [date, setDate] = useState(null);
  const lang = Cookies.get('i18next') || 'en';
  const [fullName, setFullName] = useState('');
  const { translations } = useSelector((state) => state.translation);
  const [note, setNote] = useState('');
  const [address, setAddress] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [dateError, setDateError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [noteError, setNoteError] = useState('');
  const params = new URLSearchParams(window.location.search);
  const handleCloseModal = () => {
    dispatch(callToggle({ visible: false, item: null, isCall: true }));
    setFullName('');
    setPhone('');
    setDate('');
    setAddress('');
    setNote('');
    setNameError('');
    setPhoneError('');
    setDateError('');
    setAddressError('');
    setNoteError('');
    params.delete('home-call');
    const newUrl = window.location.pathname
            + (params.toString() ? `?${params.toString()}` : '');
    window.history.replaceState({}, '', newUrl);
  };
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [visible]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { payload } = await dispatch(houseCall({
      full_name: fullName,
      phone,
      datefilter3: isCall
        ? `${String(new Date(date).getDate()).padStart(2, '0')}-${String(new Date(date).getMonth() + 1).padStart(2, '0')}-${new Date(date).getFullYear()}`
        : null,
      address,
      note: !isCall ? `${note} : ${item.title[lang]}` : note,
      lang,
      type: isCall ? 'house_call' : 'diagnostic',
      title: isCall ? 'Տնային կանչ' : `Ախտորոշման կենտրոն - ${item.title && item.title[lang]}`,
    }));
    if (payload && payload.status === 'error') {
      if (payload?.messages?.address) {
        setAddressError(payload.messages.address);
      }
      if (payload?.messages?.full_name) {
        setNameError(payload.messages.full_name);
      }
      if (payload?.messages?.phone) {
        setPhoneError(payload.messages.phone);
      }
      if (payload?.messages?.datefilter3) {
        setDateError(payload.messages.datefilter3);
      }
      if (payload?.messages?.note) {
        setNoteError(payload.messages.note);
      }
    } else {
      toast(payload && payload.message);
      handleCloseModal();
    }
  };
  const handleChangePhone = (value) => {
    setPhone(value);
  };
  if (visible) {
    return (
      <BottomPopup
        header={isCall ? translations.home_call_btn[lang] : item.title && item.title[lang]}
        handleCloseModal={handleCloseModal}
        visible={visible}
      >
        <div className="bottom-popup-form">
          <form action="#" onSubmit={handleSubmit} className="modal-form">
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label
                  htmlFor="fullName"
                  className="modal-input-block-label"
                >
                  {translations.full_name_label[lang]}
                </label>
                <input
                  value={fullName}
                  placeholder={translations.full_name_placeholder[lang]}
                  type="text"
                  id="fullName"
                  onChange={(e) => {
                    setFullName(e.target.value);
                    setNameError('');
                  }}
                  className="modal-input-block-input"
                />
                <img src={userIcon} alt="user" className="modal-input-block-input-icon" />
              </div>
              {nameError && <p className="authError">{nameError}</p>}
            </div>
            {isCall && (
              <div className="modal-input-container">

                <div className="modal-input-block">
                  <label
                    htmlFor="date"
                    className="modal-input-block-label"
                  >
                    {translations.visit_date_label[lang]}
                  </label>
                  <Calendar
                    minDate={new Date()}
                    placeholder={translations.coose_placeholder[lang]}
                    value={date}
                    onChange={(e) => {
                      setDate(e.value);
                      setDateError('');
                    }}
                    className="calendar"
                    inputClassName="calendar-input"
                    panelClassName="calendar-panel"
                    todayButtonClassName="calendar-today-button"
                    clearButtonClassName="calendar-clear-button"
                    id="date"
                    selectionMode="single"
                  />
                  {dateError && <p className="authError">{dateError}</p>}
                </div>
              </div>
            )}

            <div className="middle-block">
              {isCall && (
                <div className="modal-input-container">

                  <div className="modal-input-block">
                    <label htmlFor="address" className="modal-input-block-label">
                      {translations.address[lang]}
                      {' '}
                      *
                    </label>
                    <input
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        setAddressError('');
                      }}
                      placeholder={translations.address_placeholder[lang]}
                      type="text"
                      id="address"
                      className="modal-input-block-input address"
                    />
                    {addressError && <p className="authError">{addressError}</p>}
                  </div>
                </div>
              )}

              <div className="modal-input-container">
                <div className="modal-input-block">
                  <label htmlFor="phone" className="modal-input-block-label">
                    {translations.phone[lang]}
                    {' '}
                    *
                  </label>
                  <PhoneInput
                    id="phone"
                    country="am"
                    value={phone}
                    onChange={handleChangePhone}
                    containerClass="phone-input-container"
                    inputClass="phone-input"
                    buttonClass="phone-input-button"
                    dropdownClass="phone-input-dropdown"
                  />
                  {phoneError && <p className="authError">{phoneError}</p>}
                </div>
              </div>
            </div>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label htmlFor="comment" className="modal-input-block-label">
                  {translations.your_note[lang]}
                </label>
                <textarea
                  value={note}
                  onChange={(e) => {
                    setNote(e.target.value);
                    setNoteError('');
                  }}
                  placeholder={translations.note_placeholder[lang]}
                  type="text"
                  id="comment"
                  className="modal-input-block-input comment"
                />
                {noteError && <p className="authError">{noteError}</p>}
              </div>
            </div>
            <div className="modal-popup-actions">
              <button
                type="button"
                onClick={handleCloseModal}
                className="modal-popup-actions-button"
              >
                {translations.cancel[lang]}
              </button>
              <button
                type="submit"
                className="modal-popup-actions-button confirm"
              >
                {translations.confirm[lang]}
              </button>
            </div>
          </form>
        </div>
      </BottomPopup>
    );
  }
}

export default HouseCall;
